function changepassword(){
    var $body = $('body');
    if (!$body.hasClass('logged-in')) {
        $(window).load(function() {
            $('#header nav').fadeOut(600);
            $('.logout').on('click', function(e) {
                e.preventDefault();
                POP.logout();
            });
        });

        var bodyid = $body.attr('id');
        if (bodyid) {
            POP.attribute(bodyid + '_opened');
        }
        POP.attribute('orig_utmz', $.cookie('__utmz'), 1);
    }

    /**
     * Handle updating the user attribute callback.
     */
    function pwStatusCallback(response) {
        var $form = $('#change-password-form'),
            $alert = $form.find('.alert'),
            $btn = $form.find('button[type=submit]'),
            template = _.template($('#template-password-info').html());

        void 0;

        if (response.code == 200) {
            // handle redirection
            if (response.data.force_change && !response.data.password_reset) {
                $btn.data('url', '/panel');
            }

            // load the template
            $('#password-info').html(template(response.data)).removeClass('hidden');

            // show the form
            $('#change-password-form').removeClass('hidden');
        } else if (typeof response.msg != 'undefined') {
            POP.form.message.show(response.msg, false, $alert);
        } else {
            POP.form.message.show(POP.messages.genericError, false, $alert);
        }
    }

	/**
	 * Retrieve user attribute for whether this is the result of a password reset.
	 */
	var showTemplate = $('#password-info').length > 0 ? true : false;
	if (showTemplate) {
		$.ajax({
			type: 'GET',
			url: POP.apiBaseUrl + '/user/password_status',
			success: pwStatusCallback,
			error: $.proxy(function() {
				pwStatusCallback({code:555});
			}, this),
			dataType: "json"
		});
	}

    /**
     * Handling callback after updating a password.
     */
    function updatePasswordCallback(response) {
        var $form = $('#change-password-form'),
            $alert = $form.find('.alert'),
            $btn = $form.find('button[type=submit]');

        POP.Ajax.done($btn);

        if (response.code == 200) {
            POP.form.message.show('Your password was successfully updated.', true, $alert);

            setTimeout(function() {
                if (typeof nextPage != 'undefined' && nextPage != '') {
                    window.location = nextPage;
                } else {
                    window.location='/panel';
                }
            }, 2000);
        } else {
            if (typeof response.errors != 'undefined') {
                var htmlErrors = _.template(
                    $('#formErrorTemplate').html(),
                    { errors: response.errors.password }
                );

                POP.form.message.show(htmlErrors);
            } else if (typeof response.msg != 'undefined') {
                POP.form.message.show(response.msg);
            } else {
                POP.form.message.show(POP.messages.genericError);
            }
        }
    }

	/**
	 * Watch for form submission.
	 */
	$('#change-password-form').submit(function(e) {
	    var $form = $(this),
            $btn = $form.find('button[type=submit]'),
	        formData = $form.serialize(),
			nextPage = $('button[type=submit]', $form).data('url');

	    e.preventDefault();
        e.stopPropagation();

        if (POP.Ajax.submitting($btn)) {
            return false;
        }

	    $.ajax({
	        type: "PUT",
	        url: POP.apiBaseUrl + '/user/password',
	        data: formData,
	        success: updatePasswordCallback,
	        error: $.proxy(function() {
				POP.Ajax.error($btn);
				updatePasswordCallback({code:555})
			}, this),
	        dataType: "json"
	    }).done($.proxy(function(resp) {
			POP.Ajax.done($btn, resp);
		}, this));
    });
}
